{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "accountName",
              "displayLabel": "Account Name",
              "placeHolder": "Enter Account Name",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Account Name is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "accountNo",
              "displayLabel": "Account Number",
              "placeHolder": "Enter Account No.",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Account No is required"
                }
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
            {
                "style": {
                  "gridColumn": "span 6"
                },
                "control": {
                  "label": "bankId",
                  "displayLabel": "IFSC Code",
                  "placeHolder": "Enter IFSC Code",
                  "fieldInfo": {
                    "dataType": "picklist",
                    "lookupDetails": {
                      "apiUrl": "v1/banks/list",                  
                      "filterByKeys": ["IFSC_CODE_CONTAINS"],
                      "limit": 10,
                      "orderBy": { "name": "asc" },
                      "bindLabel": "ifscCode",
                      "bindValue": "id",
                      "additionalFilters": [
                        {
                          "name": "ACTIVE_EQUALS",
                          "alias": "active",
                          "operator": "EQ",
                          "value": ["true"]
                        }
                      ],
                      "displayColumns": [
                        { "key": "ifscCode", "header": "IFSC Code" },
                        { "key": "name", "header": "Bank" },
                        { "key": "branch", "header": "branch" }
                      ]
                    }
                  }
                },
                "validators": [
                  {
                    "type": "required",
                    "message": "Bank details are required"
                  }
                ]
            },
            {
                "style": {
                    "gridColumn": "span 6"
                },
                "control": {
                    "label": "bankName",
                    "displayLabel": "Bank Name",
                    "placeHolder": "Enter Bank Name.",
                    "disabled": true,
                    "fieldInfo": {
                        "dataType": "text"
                    }
                }
            }
        ]
      },
      {
        "formGroups": [
            {
                "style": {
                    "gridColumn": "span 6"
                },
                "control": {
                    "label": "branch",
                    "displayLabel": "Branch Name",
                    "placeHolder": "Enter Branch Name.",
                    "disabled": true,
                    "fieldInfo": {
                        "dataType": "text"
                    }
                }
            },
            {
                "style": {
                    "gridColumn": "span 6"
                },
                "control": {
                    "label": "active",
                    "displayLabel": "Active",
                    "skipLabel": true,
                    "defaultValue": true,
                    "fieldInfo": {
                        "dataType": "boolean"
                    }
                }
            }
        ]
      }
    ]
}